module.exports = __webpack_public_path__ + "static/img/kjdy02.fbebe87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/kjdy02.png
// module id = 128
// module chunks = 0